import { render, staticRenderFns } from "./AppAssessmentTermConditions.vue?vue&type=template&id=279d3a5e&scoped=true"
import script from "./AppAssessmentTermConditions.vue?vue&type=script&lang=ts"
export * from "./AppAssessmentTermConditions.vue?vue&type=script&lang=ts"
import style0 from "./AppAssessmentTermConditions.vue?vue&type=style&index=0&id=279d3a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d3a5e",
  null
  
)

export default component.exports